import axios from "axios";
import SnackbarService from "../../../app/components/theme/Snackbar/service";
import BlockUIService from "../../../app/components/theme/BlockUI/service";

const URL = `${process.env.REACT_APP_API_LOCATION}/Admin/CancellationReasons`;

const api = {
  load: async () => {
    BlockUIService.show();
    try { return (await axios.get(URL)).data; }
    catch (e: any) { await SnackbarService.show(e?.response?.data?.error?.message || "Ha ocurrido un problema", "error"); return []; }
    finally { BlockUIService.hide(); }
  },
  save: async (data: any) => {
    BlockUIService.show();
    try { const result = await axios.post(URL, data); await SnackbarService.show("El motivo se guardó correctamente", "success"); return result.data; }
    catch (e: any) { await SnackbarService.show(e?.response?.data?.error?.message || "Ha ocurrido un problema", "error"); throw e; }
    finally { BlockUIService.hide(); }
  },
  delete: async (id: string) => {
    BlockUIService.show();
    try { await axios.delete(`${URL}/${id}`); await SnackbarService.show("El motivo se eliminó correctamente", "success"); }
    catch (e: any) { await SnackbarService.show(e?.response?.data?.error?.message || "Ha ocurrido un problema", "error"); throw e; }
    finally { BlockUIService.hide(); }
  },
};

export default api;
